'use client';

import clsx from 'clsx';
import type { BadgeProps } from './types';

export default function Badge({
    children,
    startIcon,
    className,
    variant = 'default',
}: BadgeProps) {
    return (
        <span
            className={clsx('badge', `badge--${variant}`, className)}
            data-variant={variant}
        >
            {startIcon && <span className={clsx('badge__icon')}>{startIcon}</span>}
            <span className={clsx('badge__text')}>{children}</span>
        </span>
    );
}
